/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WhoareyouInputs */

const th_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณมาที่ Remy ในฐานะใด`)
};

const en_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What brings you to Remy?`)
};

const ja_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy にはどのような立場で参加されますか`)
};

const zh_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是什么把你带到了 Remy？`)
};

const es_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué te trae a Remy?`)
};

const pt_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que traz você ao Remy?`)
};

const id_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang membawa Anda ke Remy?`)
};

const fr_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu’est-ce qui vous amène sur Remy ?`)
};

const tl_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang nagdala sa iyo sa Remy?`)
};

const vi_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều gì đưa bạn tới Remy?`)
};

const ko_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 일로 Remy에 오셨나요?`)
};

const de_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was führt dich zu Remy?`)
};

const ru_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что привело вас в Remy?`)
};

const tr_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy'ye sizi ne getirdi?`)
};

const it_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa ti porta su Remy?`)
};

const pl_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co cię sprowadza do Remy?`)
};

const uk_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що привело вас до Remy?`)
};

const hi_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको Remy पर क्या लाया?`)
};

const ar_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما الذي جاء بك إلى Remy؟`)
};

const ms_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang membawa anda ke Remy?`)
};

const bn_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী আপনাকে Remy-তে এনেছে?`)
};

const zh_tw2_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是什麼把你帶到了 Remy？`)
};

const zh_hk2_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是什麼把你帶到了 Remy？`)
};

const ur_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کو Remy پر کیا لایا؟`)
};

const fa_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چه چیزی شما را به Remy آورد؟`)
};

const sw_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ni nini kilichokuleta Remy?`)
};

const nl_whoareyou = /** @type {(inputs: WhoareyouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat brengt je bij Remy?`)
};

/**
* | output |
* | --- |
* | "What brings you to Remy?" |
*
* @param {WhoareyouInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const whoareyou = /** @type {((inputs?: WhoareyouInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WhoareyouInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_whoareyou(inputs)
	if (locale === "ja") return ja_whoareyou(inputs)
	if (locale === "zh") return zh_whoareyou(inputs)
	if (locale === "es") return es_whoareyou(inputs)
	if (locale === "pt") return pt_whoareyou(inputs)
	if (locale === "id") return id_whoareyou(inputs)
	if (locale === "fr") return fr_whoareyou(inputs)
	if (locale === "tl") return tl_whoareyou(inputs)
	if (locale === "vi") return vi_whoareyou(inputs)
	if (locale === "ko") return ko_whoareyou(inputs)
	if (locale === "de") return de_whoareyou(inputs)
	if (locale === "ru") return ru_whoareyou(inputs)
	if (locale === "tr") return tr_whoareyou(inputs)
	if (locale === "it") return it_whoareyou(inputs)
	if (locale === "pl") return pl_whoareyou(inputs)
	if (locale === "uk") return uk_whoareyou(inputs)
	if (locale === "hi") return hi_whoareyou(inputs)
	if (locale === "ar") return ar_whoareyou(inputs)
	if (locale === "ms") return ms_whoareyou(inputs)
	if (locale === "bn") return bn_whoareyou(inputs)
	if (locale === "zh-TW") return zh_tw2_whoareyou(inputs)
	if (locale === "zh-HK") return zh_hk2_whoareyou(inputs)
	if (locale === "ur") return ur_whoareyou(inputs)
	if (locale === "fa") return fa_whoareyou(inputs)
	if (locale === "sw") return sw_whoareyou(inputs)
	if (locale === "nl") return nl_whoareyou(inputs)
	return en_whoareyou(inputs)
});